import React, { useState, useEffect } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { SvapoProducts } from './components/SvapoProducts';
import { Services } from './components/Services';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { AdminDashboard } from './components/AdminDashboard';
import { SiteSettings } from './components/SiteSettings';
import { ProductsManager } from './components/ProductsManager';
import { AgeVerification } from './components/AgeVerification';
import { AdminLogin } from './components/AdminLogin';
import { EditModeToggle, AdminAccessButton } from './components/EditModeToggle';
import { EditModeProvider, useEditMode } from './contexts/EditModeContext';
import { Toaster } from './components/ui/sonner';
import { Routes, Route } from 'react-router-dom';
import './App.css';

function HomePage() {
  const [ageVerified, setAgeVerified] = useState(false);
  const { isAdmin, enableAdminMode } = useEditMode();
  const [showAdminLogin, setShowAdminLogin] = useState(false);

  // Combinazione tasti Ctrl+Shift+A per aprire admin login
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.ctrlKey && e.shiftKey && e.key === 'A') {
        e.preventDefault();
        setShowAdminLogin(true);
      }
      // Escape per chiudere
      if (e.key === 'Escape') {
        setShowAdminLogin(false);
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, []);

  return (
    <>
      <AgeVerification onVerified={() => setAgeVerified(true)} />
      {ageVerified && (
        <>
          {/* Pulsante Admin RIMOSSO - ora solo Ctrl+Shift+A o URL /admin-login */}
          {showAdminLogin && !isAdmin && (
            <div style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0,0,0,0.5)',
              zIndex: 10000,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <div style={{ position: 'relative', width: '400px' }}>
                <button
                  onClick={() => setShowAdminLogin(false)}
                  style={{
                    position: 'absolute',
                    top: '-40px',
                    right: '0',
                    background: 'white',
                    border: 'none',
                    borderRadius: '50%',
                    width: '32px',
                    height: '32px',
                    cursor: 'pointer',
                    fontSize: '20px'
                  }}
                >
                  ×
                </button>
                <AdminAccessButton onAdminAccess={() => {
                  enableAdminMode();
                  setShowAdminLogin(false);
                }} />
              </div>
            </div>
          )}
          
          {isAdmin && <EditModeToggle />}
          
          <Header />
          <main>
            <Hero />
            <SvapoProducts />
            <Services />
            <Contact />
          </main>
          <Footer />
        </>
      )}
    </>
  );
}

function AdminPage() {
  const [activeTab, setActiveTab] = useState('dashboard');

  return (
    <div className="admin-page">
      <div className="admin-nav">
        <button 
          className={activeTab === 'dashboard' ? 'active' : ''}
          onClick={() => setActiveTab('dashboard')}
        >
          Prenotazioni
        </button>
        <button 
          className={activeTab === 'products' ? 'active' : ''}
          onClick={() => setActiveTab('products')}
        >
          Prodotti SVAPO
        </button>
        <button 
          className={activeTab === 'settings' ? 'active' : ''}
          onClick={() => setActiveTab('settings')}
        >
          Impostazioni Sito
        </button>
      </div>
      
      {activeTab === 'dashboard' && <AdminDashboard />}
      {activeTab === 'products' && <ProductsManager />}
      {activeTab === 'settings' && <SiteSettings />}
    </div>
  );
}

function App() {
  return (
    <EditModeProvider>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
        <Toaster />
      </div>
    </EditModeProvider>
  );
}

export default App;
